// extracted by mini-css-extract-plugin
export var discoverMoreShipPrint = "ShipIntro-module--discover-more-ship-print--1001c";